import NAvatar, { NAvatarProps } from '../../../libs/nif-web-components/src/microcomponents/NAvatar';
import { useMemo } from 'react';
import { createAvatar } from '@dicebear/core';
import {staffMemberAvatars} from '@next-is-free-monorepo/globals';
import { notionists } from '@dicebear/collection';

interface StaffMemberAvatarProps extends NAvatarProps {
  id: string;
}

const StaffMemberAvatar = (props: StaffMemberAvatarProps) => {

  const avatar = useMemo(() => {
    return createAvatar(staffMemberAvatars, {
      seed: props.id,
    }).toDataUri();
  }, [props.id]);

  return (
    <NAvatar {...props}>
      <img src={avatar} className={'w-full'} alt="Avatar" />
    </NAvatar>
  );
};
export default StaffMemberAvatar;
